__turbopack_context__.v({
  "aurora": "archive-page-module__Gan61G__aurora",
  "buttonSlot": "archive-page-module__Gan61G__buttonSlot",
  "buttons": "archive-page-module__Gan61G__buttons",
  "buttonsRow": "archive-page-module__Gan61G__buttonsRow",
  "eyebrow": "archive-page-module__Gan61G__eyebrow",
  "fame": "archive-page-module__Gan61G__fame",
  "hero": "archive-page-module__Gan61G__hero",
  "inner": "archive-page-module__Gan61G__inner",
  "lead": "archive-page-module__Gan61G__lead",
  "page": "archive-page-module__Gan61G__page",
  "search": "archive-page-module__Gan61G__search",
  "supportLink": "archive-page-module__Gan61G__supportLink",
  "supportNote": "archive-page-module__Gan61G__supportNote",
  "title": "archive-page-module__Gan61G__title",
  "tourButton": "archive-page-module__Gan61G__tourButton",
});
